import styled from "styled-components";
import React from "react";

interface Props {
  isCorrect: boolean;
  turn: number;
  solution: string;
}

const Modal: React.FC<Props> = ({ isCorrect, turn, solution }) => {
  return (
    <Container className="modal">
      {isCorrect && (
        <Postcard className="win">
          <span className="stamp">✈ Destination atteinte</span>
          <h1>Bon voyage !</h1>
          <p className="solution">Tu as trouvé : {solution}</p>
        </Postcard>
      )}
      {!isCorrect && (
        <Postcard className="lose">
          <span className="stamp">🧭 Égaré en route</span>
          <h1>Perdu</h1>
          <p className="solution">La solution était : {solution}</p>
        </Postcard>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;

  background: rgba(4, 32, 46, 0.72);
  backdrop-filter: blur(2px);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  color: #fff;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

const Postcard = styled.div`
  max-width: 480px;
  min-width: 300px;
  background: #f8f1e1;
  color: #0b3d55;
  padding: 40px;
  border-radius: 12px;
  border: 2px dashed #d9a234;
  margin: 10% auto;
  box-shadow: 0 20px 45px rgba(4, 32, 46, 0.5);
  font-family: "Poppins", sans-serif;

  > .stamp {
    display: inline-block;
    font-size: 0.85rem;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #c9941f;
    border: 1px solid #c9941f;
    border-radius: 999px;
    padding: 4px 14px;
    margin-bottom: 12px;
  }

  > h1 {
    font-family: "Playfair Display", serif;
    font-weight: 700;
  }

  &.lose > .stamp {
    color: #c1502e;
    border-color: #c1502e;
  }

  > .solution {
    font-size: 1.25rem;
    letter-spacing: 1px;
    padding-top: 20px;
  }
`;

export default Modal;
